import { ROUTES } from '@constants/index'

export const getDefaultView = (fallbackView?: string): string => {
  return fallbackView ?? ROUTES.START
}
